import { render, staticRenderFns } from "./SimpleWithChild.vue?vue&type=template&id=4d04d706&scoped=true"
import script from "./SimpleWithChild.vue?vue&type=script&lang=js"
export * from "./SimpleWithChild.vue?vue&type=script&lang=js"
import style0 from "./SimpleWithChild.vue?vue&type=style&index=0&id=4d04d706&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d04d706",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d04d706')) {
      api.createRecord('4d04d706', component.options)
    } else {
      api.reload('4d04d706', component.options)
    }
    module.hot.accept("./SimpleWithChild.vue?vue&type=template&id=4d04d706&scoped=true", function () {
      api.rerender('4d04d706', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/infra/questionConfig/subViews/detail/components/SimpleWithChild.vue"
export default component.exports